<template>
    <div class="filterbar-analytics-correctness">
        <button
            v-for="filtertag in filtertags" :key="filtertag.id"
            class="filterbar-analytics-correctness__filtertag"
            :class="selectionClass(filtertag)"
            @click="selectFiltertag(filtertag)">
            <span class="filterbar-analytics-correctness__filtertag-text">{{ filtertag.text }}</span>
        </button>
    </div>
</template>
<script>
    export default {
        props: {
            categoryLabel: {
                type: String,
            },
            filtertagLabel: {
                type: String,
            }
        },

        computed: {
            filtertags(){
                return this.$store.state.filtertags[this.categoryLabel][this.filtertagLabel];
            }
        },

        methods: {
            selectionClass(filtertag){
                let selectedFiltertagType = this.$store.state.selectedFiltertag[this.categoryLabel][this.filtertagLabel].type;
                if(selectedFiltertagType === filtertag.type){}
                return selectedFiltertagType === filtertag.type
                       ? 'filterbar-analytics-correctness--selected-filtertag'
                       : '';
            },

            selectFiltertag(filtertag){
                this.$store.commit('setSelectedFiltertag', {
                    categoryLabel: this.categoryLabel,
                    filtertagLabel: this.filtertagLabel,
                    filtertag: filtertag
                });
                this.$store.state.sfx.filterbarClick.currentTime = 0;
                this.$store.state.sfx.filterbarClick.play();
            }
        }
    };
</script>
<style scoped src="@/css/components/filterbar-analytics-correctness.css"></style>